
import { defineComponent } from 'vue';
import store from '@/data/store';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    showLogOut: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n();

    const doLogout = () => {
      if (confirm(t('general.alerts.confirm_logout'))) {
        store.dispatch('logout');

        location.reload();
      }
    };

    return {
      props,
      doLogout,
    };
  },
});
